export default __webpack_public_path__ + "static/media/RobotoMono-ExtraLight.d8e13083.woff";